





import JsonViewer from 'vue-json-viewer'
import {Component, Vue} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import VisualComponent from "@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue";

@Component({
    components: {
        JsonViewer,
        VisualComponent
    }
})
export default class NewOverview extends Vue {
    name= "NewOverview";
    @Getter base_url !: any;
    @Getter auth_header !: any;
    @Getter token !: any;
    @Getter math_service_url !: any;
    @Getter currentExperimentalDatasetID !: any;
    @Getter validationParameters !: any;
    @Mutation SET_BREADCRUMB!: (_ : any) => any;
    @Mutation CHANGE_EXPERIMENTAL_DATASET_ID!: (_ : any) => any;
    @Mutation CHANGE_OVERVIEW_SIMPLIFY!: (_ : boolean) => any;
    response: any = {overview:null};

    mounted () {
        this.CHANGE_OVERVIEW_SIMPLIFY(false);
        this.setBreadcrumb();
        let datasetId = this.$route.params.dataset_id;
        this.setExperimentalDatasetId(datasetId)
        this.getDatasetOutput(datasetId);
    }

    setExperimentalDatasetId(datasetId: any) {
        this.CHANGE_EXPERIMENTAL_DATASET_ID(datasetId)
    }

    setBreadcrumb(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    }

    private getDatasetOutput(datasetId: string) {
        let outputUrl = this.math_service_url+"dataset/"+
            datasetId+"/output/";
        console.log("GET from ",outputUrl);
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios
            .get(
                outputUrl,
                {
                    headers: {
                        jwt: this.token
                    },
                    withCredentials: true
                }
            )
            .then(response => {
                console.log("Got response",response);
                this.response.overview = response.data.overview;
            })
            .catch(error => {
                console.log("error on GET dataset info", error);
            });
    }
}
